import React from 'react'

import IconButton, { IconButtonProps as DefaultButtonProps } from '@mui/material/IconButton'
import Tooltip, { TooltipProps } from '@mui/material/Tooltip'

export type ButtonProps = DefaultButtonProps & {
  children: React.ReactNode
  tooltipTitle?: string
  placement?: TooltipProps['placement']
}

const IconButtonComponent = ({ children, tooltipTitle = '', placement = 'right', ...props }: ButtonProps) => {
  return tooltipTitle ? (
    <Tooltip title={tooltipTitle} placement={placement}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <IconButton {...props}>{children}</IconButton>
    </Tooltip>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <IconButton {...props}>{children}</IconButton>
  )
}

export default IconButtonComponent
